module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABJUlEQVRYR+1WsW3DMBC8Zy0g3iCq9SyygZVJ7A3iDeJsIG+QTGJlgxSkao0gA6r5AQlbUGAErkixEFsCvPu745GEhRctjI+VwKQAMx+I6CmRJYMx5uSxAoGqqhql1Fsi8ADjnDt1XXcIBLTWLYBtSgIAvo0xdR4K+Ml9BgDURLSJqYSIDABaa20zZSAm4KOz1x7ISwFmflFKRS0j59zFWvtzy0ZQwAMT0RlA1BswC+QgIq+eSB5FtHgTXi3wdRzV/5kFFxGpJwtuG1ciUXPgm/AuhI/aKuZ+Xj0Qc9L/zs5HAWbeE9FzChVEpLfWfk3Psdb6COA9BfgM48MYc8yjCZn5k4h2KRX48ykty3JTFEX4kiUi0Y7j2PR9P+RzCxJNfgezKvALfddyIVVoDAEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/catalog.png
// module id = kuNE
// module chunks = 5